/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Stage
 */
export interface Stage {
    /**
     * 
     * @type {number}
     * @memberof Stage
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Stage
     */
    sequence: number;
}

/**
 * Check if a given object implements the Stage interface.
 */
export function instanceOfStage(value: object): value is Stage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    return true;
}

export function StageFromJSON(json: any): Stage {
    return StageFromJSONTyped(json, false);
}

export function StageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'sequence': json['sequence'],
    };
}

export function StageToJSON(json: any): Stage {
    return StageToJSONTyped(json, false);
}

export function StageToJSONTyped(value?: Stage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'sequence': value['sequence'],
    };
}

